// client/src/features/buildings/my/search.ts — the search of both shells' „Clădire" route · D-3368.
//
// `ticket` is the one parameter, declared on BOTH routes (`/app/my-building`, `/portal/building`) so
// the notification links lanes 3 and 4 write — `?ticket=<id>` — survive the router, and their blocks
// read it with the router's non-strict search hook. An id that is not a uuid is dropped rather than
// failing the route, as `?tab=` is on the clădire profile.

import { z } from 'zod';

export const myBuildingSearchSchema = z.object({
  ticket: z.uuid().optional().catch(undefined),
});

export type MyBuildingSearch = z.infer<typeof myBuildingSearchSchema>;
